import { Line } from 'recharts';
import { TREND_COLOR } from '../../lib/chart-colors.ts';

/**
 * La media móvil dibujada sobre una serie.
 *
 * Se usa dentro de un `ComposedChart` de recharts, junto a las barras del día.
 * No es un componente que renderice por su cuenta: recharts inspecciona el tipo
 * de sus hijos, así que esto devuelve un `<Line>` con la configuración correcta
 * en vez de envolverlo.
 *
 * `connectNulls` queda en `false` a propósito. Los primeros puntos de una media
 * móvil son `null` —todavía no hay ventana completa— y unirlos dibujaría una
 * línea desde el origen que nadie midió. Es preferible que el tramo no exista.
 */
export function LineaDeTendencia({
  dataKey = 'tendencia',
  name = 'Tendencia',
}: {
  dataKey?: string;
  name?: string;
}) {
  return (
    <Line
      type="monotone"
      dataKey={dataKey}
      name={name}
      stroke={TREND_COLOR}
      strokeWidth={2}
      dot={false}
      // El último punto sí se marca: es "dónde estamos", y una línea que termina
      // en el vacío deja al ojo sin ancla.
      activeDot={{ r: 4 }}
      connectNulls={false}
      isAnimationActive={false}
    />
  );
}
